import React, { useEffect } from 'react';
import cx from 'classnames';

import { ModalProvider, useModalContext } from '@magoosh/context/modal_context';
import { DangerBadge, SuccessBadge } from '@magoosh/lib/badge';
import { FontAwesomeIcon } from '@magoosh/lib/icons';

import { AudioSetupModal, hasCompletedAudioSetup } from '../index';

interface Props {
  autoPresentModal?: boolean;
  className?: string;
  showStatus?: boolean;
}

const AudioSetupButton = (props: Props) => {
  const { setModal } = useModalContext();

  useEffect(() => {
    if (props.autoPresentModal && !hasCompletedAudioSetup()) {
      presentAudioSetupModal();
    }

  }, []);

  const presentAudioSetupModal = () => {
    setModal({
      body: (
        <AudioSetupModal
          onClose={() => setModal(null)}
          onFinished={() => setModal(null)}
        />
      ),
      header: 'Audio/Microphone Setup'
    });
  };

  return (
    <div className={cx(props.className, 'align-items-center d-flex gap-s')}>
      {
        props.showStatus && (
          hasCompletedAudioSetup() ? (
            <SuccessBadge>Setup Complete!</SuccessBadge>
          ) : (
            <DangerBadge>Setup Needed!</DangerBadge>
          )
        )
      }

      <div onClick={presentAudioSetupModal} style={{ cursor: 'pointer' }}>
        <div className="align-items-center d-flex gap-xs">
          <FontAwesomeIcon icon="gear" />
          <div className="nowrap">Audio/Mic Setup</div>
        </div>
      </div>
    </div>
  );
};

export default (props: Props) => {
  return (
    <ModalProvider>
      <AudioSetupButton {...props} />
    </ModalProvider>
  );
};
